import axiosInstance from '../config/axios';

const getAuthHeader = (extraHeaders = {}) => {
  const token = localStorage.getItem('authToken');
  return {
    ...extraHeaders,
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };
};

/**
 * Fetch list of videos
 * @param {object} params Optional pagination or filtering parameters
 */
export const getVideosApi = (params = {}) =>
  axiosInstance.get('/list-videos', { params, headers: getAuthHeader() }).then((res) => res.data);

export const likeVideoApi = (videoId, userId) =>
  axiosInstance.post(`/like`, { video_id: videoId, user_id: userId }, { headers: getAuthHeader() }).then((res) => res.data);

export const saveVideoApi = (videoId) =>
  axiosInstance.post(`/save-post`, { post_id: videoId }, { headers: getAuthHeader() }).then((res) => res.data);

export const shareVideoApi = (videoId, userId, platform = 'web') =>
  axiosInstance.post(`/share`, { video_id: videoId, user_id: userId, platform }, { headers: getAuthHeader() }).then((res) => res.data);

export const getCommentsApi = (videoId) =>
  axiosInstance.get(`/posts/${videoId}/comments`, { headers: getAuthHeader() }).then((res) => res.data);

export const addCommentApi = (videoId, userId, comment) =>
  axiosInstance.post(`/comment`, { video_id: videoId, user_id: userId, comment }, { headers: getAuthHeader() }).then((res) => res.data);
